import { FC, useRef } from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import { getUptimeColor, Uptime, UptimeInfo } from './Util'
import _ from 'lodash'
import { useHistory } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip'
import { strings } from 'strings'
import { MountpointStatus } from 'api'

export interface LinkUptimeBarChartItem {
  id: number
  name: string
  uptime: Uptime
  disconnectPercents: {
    start: { percent: number; date: string }
    end: { percent: number; date: string }
    w: number
  }[]
}

export interface LinkUptimeBarChartProps {
  className?: string
  items: LinkUptimeBarChartItem[]
  // showDisconnects: boolean
}

export const LinkUptimeBarChart: FC<LinkUptimeBarChartProps> = ({
  className,
  items,
  // showDisconnects,
}) => {
  const classes = useStyles()
  return (
    <div className={`${classes.root} ${className}`}>
      {/* {items.map((i) => (
        <Item {...i} clickable key={i.name} />
      ))} */}
    </div>
  )
}

const useStyles = makeStyles({
  root: {
    flip: false,
    direction: 'ltr',
    columnCount: 'auto',
    columnWidth: 250,
  },
})

export interface ItemProps {
  mountpointId: number
  mountpointName: string
  onlinePercent: number
  allConnections: UptimeInfo['allConnections']
  disconnectionsCount: number
  clickable?: boolean
}
export const Item: FC<ItemProps> = ({
  mountpointId,
  mountpointName,
  clickable,
  allConnections,
  onlinePercent,
  disconnectionsCount,
}) => {
  const classes = useItemStyles()
  const ref = useRef<SVGSVGElement | null>(null)
  const history = useHistory()

  const title =
    allConnections.length === 0
      ? mountpointName
      : `${mountpointName} ${_.round(
          onlinePercent,
          2,
        )}% #${disconnectionsCount}`

  return (
    <div>
      <div
        className={classes.root}
        onClick={() => {
          if (clickable) history.push(`/mountpoint/${mountpointId}/logs`)
        }}
      >
        <Typography
          style={{ color: getUptimeColor(onlinePercent) }}
          className={classes.name}
        >
          {title}
        </Typography>
        <svg width="100%" height="15" ref={ref}>
          <rect width="100%" height="100%" fill="#f1f1f1" />

          {allConnections.map((l, i) => (
            <Tooltip
              title={
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <p>{`${strings.start}: ${l.start}`}</p>
                  <p>{`${strings.end}: ${l.end}`}</p>
                  {l.duration && <p>{`${strings.range}: ${l.duration}`}</p>}
                </div>
              }
              key={i.toString()}
            >
              <rect
                x={`${l.startPosition}%`}
                width={`${l.percent}%`}
                height="100%"
                fill={l.status === MountpointStatus.Online ? 'green' : 'red'}
              />
            </Tooltip>
          ))}
        </svg>
      </div>
    </div>
  )
}

const useItemStyles = makeStyles((theme) => ({
  root: {
    flip: false,
    display: 'flex',
    flexDirection: 'column',
    pageBreakInside: 'avoid',
    paddingBottom: theme.spacing(1),
    cursor: 'pointer',
  },
  name: {
    flip: false,
    fontSize: '0.8rem',
    color: '#5a5a5a',
  },
}))
